import React from "react";
import TimelinePost from "./TimelinePost";
import { useGlobalContext } from "store/contexts/globalContext";

var styles = {
  noListContainer: {
    display: "flex",
    marginTop: "20px",
    alignItems: "center",
    flexDirection: "column",
  },
};

export default ({ posts, total, teamId }) => {
  const classes = styles;
  const { ringCentral } = useGlobalContext();

  if (total === 0) {
    return (
      <React.Fragment>
        <div style={classes.noListContainer}>
          <div className="noPostText">
            {!ringCentral && <span>Currently No Post Available</span>}
            {ringCentral && (
              <span>You are not authorized to access this team</span>
            )}
          </div>
        </div>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      {posts.map((post, index) => (
        <TimelinePost key={post.id} post={post} index={index} teamId={teamId} />
      ))}
    </React.Fragment>
  );
};
